import ConversationAPI from '../../api/conversations';
import types from '../mutation-types';

export const state = {
  count: 0,
};

export const getters = {
  getUnreadMessagesCount($state) {
    return $state.count;
  },
};

export const actions = {
  get: async function getUnreadMessagesCount({ commit }) {
    try {
      const response = await ConversationAPI.getUnreadMessagesCount();
      commit(types.SET_UNREAD_MESSAGES_COUNT, response.data.count);
    } catch (error) {
      // Keep the last known count so the favicon does not flicker on network errors.
    }
  },
  clear({ commit }) {
    commit(types.SET_UNREAD_MESSAGES_COUNT, 0);
  },
};

export const mutations = {
  [types.SET_UNREAD_MESSAGES_COUNT]($state, count) {
    const parsedCount = Number(count);
    $state.count =
      Number.isFinite(parsedCount) && parsedCount > 0 ? parsedCount : 0;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
